import React from 'react';
import {Button} from 'react-bootstrap';
export default props => {
  const {isUpdating, initialize} = props;
  return (
    <div className="controls">
      <Button bsStyle="info" disabled={isUpdating} onClick={initialize}>
        Refresh
      </Button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/users/Controls.jsx